import React from 'react'
import PropTypes from 'prop-types'
import { StyledCheckbox, StyledCheckboxWrapper } from './styles'

const Checkbox = (props) => {
  const { showError, required, children, formProperties, theme, ...rest } =
    props

  return (
    <StyledCheckboxWrapper>
      <StyledCheckbox
        type="checkbox"
        required={required}
        {...formProperties}
        {...rest}
        invalid={showError}
        theme={theme}
      />
      <label htmlFor={formProperties.name}>{children}</label>
    </StyledCheckboxWrapper>
  )
}

Checkbox.defaultProps = {
  showError: false,
  required: false,
  children: <></>,
  formProperties: {},
}

Checkbox.propTypes = {
  showError: PropTypes.bool,
  required: PropTypes.bool,
  children: PropTypes.any,
  formProperties: PropTypes.object.isRequired,
}

export { Checkbox }
